const AnalyseProjectPage = () => {
  return <>analyse</>;
};

export default AnalyseProjectPage;
